import enMessages from '../../_metronic/i18n/messages/en.json'
import esMessages from '../../_metronic/i18n/messages/es.json'
import jaMessages from '../../_metronic/i18n/messages/ja.json'

export const AllMessages = {
  en: enMessages,
  vi: esMessages,
  jp: esMessages,
}

export const TranslateDOM = () => {
  const timeoutId = setTimeout(() => {
    let test = document.querySelectorAll(
      'label, span, small, h2, h3, h4, h6, button,p, legend, a, h1, div, h5, [aria-label="test"], tspan'
    )
    let arrLang = localStorage.getItem('multi-lang-json')
    if (!arrLang) return
    let parse = JSON.parse(arrLang)
    test.forEach((e: any) => {
      if (e.innerText) {
        let checkRequired = e.innerText.includes('*')
        if (!checkRequired) {
          let test = e.innerHTML
          if (e.innerHTML.includes('span')) {
            test = test.substring(0, test.indexOf('<'))
          }
          let check = parse.find((o: any) => o.key.toLowerCase() == test.toLowerCase())
          if (check) {
            e.innerHTML = check.value
          }
        } else {
          let string = e.innerText.toLowerCase().replace(' *', '')
          let check = parse.find((o: any) => o.key.toLowerCase() == string)
          if (check) {
            e.innerHTML = check.value + `<span style='color: red'> *</span>`
          }
        }
      }
    })
  }, 200)
  return () => {
    clearTimeout(timeoutId)
  }
}
